<template>
   <!--v-model="menu2"-->
   <!--:return-value.sync="date"-->
   <!--@blur="date = parseDate(value)"-->
   <!--:close-on-content-click="false"-->
   <v-flex pb-0 pt-1 v-bind="$attrs" v-if="uCanSee" xs12>
      <v-menu :close-on-content-click="false"
              :nudge-right="40"
              full-width
              lazy
              min-width="290px"
              offset-y ref="dateMenu" transition="scale-transition"
              v-model="menu">

         <v-text-field
                 :placeholder="pholder" :rules="validationRules" class="clean-style" box
                 @blur="onEditorBlur" append-icon="event"
                 browser-autocomplete="nope" mask="##/##/####"
                 ref="dateEditor"
                 return-masked-value
                 slot="activator"
                 v-bind="$attrs"
                 v-model="dateFormatted"
                 validate-on-blur></v-text-field>

         <v-date-picker @input="onDatePick" no-title ref="datePicker" locale="pt-BR" type="date" v-bind="attrs"
                        v-model="date"></v-date-picker>

      </v-menu>
   </v-flex>
</template>

<script>
    import Rules from './validationRules';

    export default {
        name: 'a-date-field',

        props: {
            value: {
                required: false
            },
            floating: {
                type: Boolean,
                required: false,
                default: false
            },
            validate: {
                type: String,
                required: false
            },
            rid: {
                type: String,
                required: false
            },
            dateFormat: {
                type: String,
                required: false,
                default: 'MM/DD/YYYY'
            },
            birthDate: {
                type: Object,
                required: false
            }
        },

        data () {
            return {
                menu: false,
                dateFormatted: null,
                date: null,
                uCanSee: true,
                minMax: {}
            };
        },

        watch: {
            menu (newVal) {
                if (this.birthDate && newVal) {
                    setTimeout(() => (this.$refs.datePicker.activePicker = 'YEAR'));
                }
            },
            value: {
                handler: function (newValue) {
                    this.date = newValue ? newValue.split(/[ |T]/)[0] : newValue;
                },
                immediate: true
            },
            date: {
                handler: function () {
                    this.dateFormatted = this.formatDate(this.date);
                    this.$emit('input', this.date);
                },
                immediate: true
            },
            dateFormatted (newVal, oldVal) {
                if (!newVal && this.value && !this.$refs.dateEditor.isFocused) { //to overcome form reset cleanup.
                    this.$nextTick(() => this.dateFormatted = this.formatDate(this.value));
                }
            }
        },

        methods: {
            onEditorBlur () {
                this.date = this.parseDate(this.dateFormatted);
                if (!this.date) {
                    this.dateFormatted = null;
                }
            },
            onDatePick () {
                this.$refs.dateMenu.save(this.date);
                this.$refs.dateEditor.focus();
            },
            formatDate (date) {
                if (!date && !this.$moment(date).isValid()) return null;
                return this.$moment(date).format(this.dateFormat);
            },
            parseDate (date) {
                if (!date) return null;
                let parsed = this.$moment(date, this.dateFormat).format('YYYY-MM-DD');
                // console.log(date);
                // console.log('parsed:', this.$moment(date, this.dateFormat).format('YYYY-MM-DD'));
                return parsed.match('Invalid') ? null : parsed;
            }
        },

        computed: {
            listeners () {
                return {
                    ...this.$listeners
                };
            },

            attrs () {
                return Object.assign({}, this.$attrs || {}, this.minMax);
            },

            pholder () {
                let prop = this.placeholder;
                return (this.floating) ? (prop || '') : ' ';
            },

            validationRules () {
                let rules = [];
                //TODO: validate date range if min and max is defined;
                if (this.validate) {
                    let rulesArray = this.validate.split(',');
                    rulesArray.forEach(r => rules.push(Rules[r.trim()]));
                }

                return rules;
            }
        },

        created () {
            if (this.birthDate) {
                this.minMax.min = this.$moment().subtract(this.birthDate.maxAge || 80, 'years').format('YYYY-MM-DD');
                this.minMax.max = this.$moment().subtract(this.birthDate.minAge || 18, 'years').format('YYYY-MM-DD');
            }
            this.uCanSee = this.$uCan({
                rid: this.rid,
                op: 'S'
            });
        }

    };
</script>

<style>


</style>


// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/components/ADateField.vue